'use client';

import React from 'react';
import { Arr, DebounceClosure, DebouncedFunction, cancelableDebounce } from '@benzinga/utils';

export const useDebounce = <T extends DebouncedFunction<E>, E extends Arr = Parameters<T>>(
  debouncedFunc: T,
  maxWait: number,
): DebounceClosure<T, E> => {
  const [fn, cancel] = React.useMemo(() => cancelableDebounce<T, E>(debouncedFunc, maxWait), [debouncedFunc, maxWait]);
  React.useEffect(() => {
    return () => {
      cancel();
    };
  }, [cancel]);

  return fn as DebounceClosure<T, E>;
};
